import axios from 'axios';

// export const SERVER_URL = 'http://localhost:8000';
export const SERVER_URL = 'https://arine.kz';

export const request = ({method = 'get', url, data, headers}) => {
  const token = window.localStorage.getItem('token@quiz-client');
  const auth_header = token ? {Authorization: 'JWT ' + token} : {};
  return axios({
    method,
    url: `${SERVER_URL}${url}/`,
    data,
    headers: {'Content-Type': 'application/json', ...headers, ...auth_header},
  });
};
